<template>
<div id="news" class="mx-0 mx-md-3 pa-0 ">
    <v-row row wrap class="mb-0 ml-5 mr-1 mt-3">
        <span v-if="department.name" class="text-h6 blue--text text--darken-4 py-0">
            <span v-html="department.name[language]"></span>
            &nbsp;&nbsp;{{department.sigle}}
        </span>
    </v-row>
    <v-row row wrap class="mb-0 ml-5 my-0">
        <p id="prod" class="ml-0 mb-0 pt-2 pb-0">
            <router-link class="my-0 pr-4 productions text-subtittle-2 "
                :to="{name:'publications', params:{idDepartment:idDepartment}}"  >
                <a class="purple--text text--darken-4">
                    {{ $t("production.publications") }}
                </a>
            </router-link>
            <router-link class="my-0 pr-4 productions text-subtittle-2 "
                :to="{name:'grants-department', params:{id:idDepartment}}"  >
                <a class="purple--text text--darken-4">
                    {{ $t("production.grants") }}
                </a>
            </router-link>
            <router-link class="my-0 pr-4 productions text-subtittle-2 "
                :to="{name:'lectures', params:{idDepartment:idDepartment}}"  >
                <a class="purple--text text--darken-4">
                    {{ $t("production.lectures") }}
                </a>
            </router-link>
        </p>
    </v-row>
    <v-row wrap class="mb-0  ml-5 mr-1 mt-2 ">
        <v-card class="pa-0 ma-0" flat color="#f8f9fa" min-width="100%">
            <v-card-text class="ml-0 px-0 py-0">
                <router-link v-if="department.head" class="blue--text text--darken-4 text-subtitle-1 pt-2 pb-0"
                    :to="{name:'researcher',params:{id:department.head.id}}" tag="p" >
                    {{ $t("department.head") }}:
                    <a>
                        <span v-html="department.head.last_name" class="blue--text text--darken-4  font-weight-bold pr-1"></span>
                        <span v-html="department.head.first_name" class="blue--text text--darken-4" ></span>
                    </a>
                </router-link>
                <p v-if="department.description" class="text-justify  body-2 my-0 pr-1 pb-1  lineheight ql-editor" v-html="department.description[language]"></p>
            </v-card-text>
            <v-card-text justify-start class=" mt-0 mb-1 py-0 ">
                <v-btn text color="orange" class=" ml-n4 mb-2 pl-0" @click="researchThemes =!researchThemes">
                    <img v-if="!researchThemes" class="mr-1" src="../../assets/departments/outline-expand_more-24px.svg">
                    <img v-else class="mr-1" src="../../assets/departments/outline-expand_less-24px.svg">
                    {{ $t("department.themes") }}
                </v-btn>
                <div v-if="themes" class="row">
                    <ul id="researchThemes"  v-if="researchThemes" class="description ml-3 themes">
                        <template v-for="(themeItem, index, key) in themes"  >
                            <p v-if="themeItem" class="indigo--text mt-1 mb-0 ml-n4" :key="key"> {{themeItem.theme}}</p>
                            <li v-for="(item,index) in themeItem.items" :key="themeItem.id+'_'+index">{{item.item}}</li>
                        </template>
                    </ul>
                </div>
            </v-card-text>
            <v-card-text class="ma-0 my-0 py-0">
                <v-btn text color="orange" class="ml-n4 mt-2 pl-0" @click="members=!members">
                    <img v-if="!members" class="mr-1" src="../../assets/departments/outline-expand_more-24px.svg">
                    <img v-else class="mr-1" src="../../assets/departments/outline-expand_less-24px.svg">
                    {{ $t("department.members") }}
                </v-btn>
                <v-row v-if="members">
                    <v-col  v-for="(members,index) in membersBlock" :key="'i'+index" cols="12" sm="6"  md="4" lg="3" xl="3">
                        <router-link  v-for="(item, index) in members" :key="index"
                            :to="{name:'researcher',params:{id:item.id}}" tag="p"  class="blue--text text--darken-4 my-0 pt-0 pb-1 pl-0 pl-sm-3">
                            <a class="purple--text text--darken-4 pr-2">
                                <span class="blue--text text--darken-4 font-weight-medium" v-html="item.last_name"></span>
                                <span v-html="item.first_name" class="blue--text text--darken-4"></span>
                                <span class="font-italic  grey--text text--darken-1 pl-1">{{ item.category }} </span>
                                <span class="font-italic text-caption grey--text text--darken-1 pl-1">(from {{ item.start }})</span>
                            </a>
                        </router-link>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text class="ma-0 py-0">
                <v-btn text color="orange" class="ml-n4 mt-0 mb-2 pl-0" @click="getVisitors">
                    <img v-if="!currentVisitors" class="mr-1" src="../../assets/departments/outline-expand_more-24px.svg">
                    <img v-else class="mr-1" src="../../assets/departments/outline-expand_less-24px.svg">
                    {{ $t("department.visitors") }}
                </v-btn>
                <div v-if="currentVisitors" class="mb-2">
                    <div v-if="visitors">
                        <p v-for="(item, index) in visitors" :key="'i'+index"
                            class="my-0 py-0 pl-0 pl-sm-3 black--text  ">
                            <span class="font-weight-medium" v-html="item[0].visiting.last_name"></span>
                            <span v-html="item[0].visiting.first_name"></span>
                            <span class="font-italic text-caption  pl-1">
                                 {{item[0].start| dateEU('DD.MM.YYYY')}}&minus;{{item[0].end| dateEU('DD.MM.YYYY')}}
                            </span>,&nbsp;
                            <span v-html="item[0].visiting.city"></span>,
                            <span v-html="item[0].visiting.country"></span>
                        </p>
                    </div>
                    <p v-else>No visitors in {{ yyyy }}</p>
                </div>
            </v-card-text>
            <v-card-text class="ma-0 py-0">
                <v-btn text color="orange" class="ml-n4 mt-0 mb-2 pl-0" @click="getFormerMembers">
                    <img v-if="!formerMembers" class="mr-1" src="../../assets/departments/outline-expand_more-24px.svg">
                    <img v-else class="mr-1" src="../../assets/departments/outline-expand_less-24px.svg">
                    {{ $t("department.membersFormer") }}
                </v-btn>
                <v-row v-if="formerMembers" class="mb-2">
                    <v-col  v-for="(formers,index) in membersFormerBlock" :key="'i'+index"
                        cols="12" sm="6"  md="4" lg="3" xl="3" class="my-0 py-0">
                            <p v-for="(item, index) in formers" :key="'i'+index"
                                class="my-0 py-0 pl-0 pl-sm-3 grey--text text--darken-1 ">
                                <span class="font-weight-medium" v-html="item.last_name"></span>
                                <span v-html="item.first_name"></span>
                                <span class="font-italic  text-caption grey--text text--darken-1 pl-1">{{ item.category }}</span>
                                <span class="font-italic text-caption grey--text text--darken-1 pl-1">({{ item.start }} - {{item.end}})</span>
                            </p>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-row>
  </div>
</template>
<script>
// import data

    import {mapGetters} from 'vuex';

    export default {
    name: 'Departments',
    metaInfo() {
        return{
            title: this.title,
            meta: [
                {vmid: "description", name: "description", content: this.theme},
                {vmid: "keywords", name: "keywords", content:  this.wordskeys}
            ]
        }
    },
    data(){
        return {
        idDepartment:null,
        researchThemes:true,
        scientifiqueProduction: false,
        formerMembers: false,
        currentVisitors:false,
        department:[],
        themes:[],
        themeItem:[],
        members:true,
        membersBlock:[],
        membersFormerBlock:[],
        visitors:[],
        yyyy: new Date().getFullYear(),
        theme:"",
        wordskeys:"",
        title:"",
        }
    },
    created(){
        this.idDepartment =  this.$route.params.id;
        this.getThemes(this.idDepartment);
        this.getInfosDepartment(this.idDepartment);
        this.getResearchers(this.idDepartment,0) ;
    },
    mounted () {
        if(this.mdAndDown == false){
            this.researchThemes = true;
        };
        this.idDepartment = this.$route.params.id;
    },
    computed: {
        ...mapGetters('header',{
            language:'language',
            smAndDown:'smAndDown',
            mdAndDown:'mdAndDown',
        }),
    },
    methods:{
        getThemes(idDepartment){
            if(this.themes.length == 0 )
                this.getThemesItems(idDepartment);
        },
        async getThemesItems(idDepartment){
            var departmenThemes_path = '/index.php/api/department/themes/'+idDepartment;
            try{
                const res = await axios.get(departmenThemes_path);
                if(res){
                    const departmentThemes= res.data;
                    if(departmentThemes.length > 0){
                        this.themes= departmentThemes;
                        this.theme = departmentThemes[0].theme;
                    }

                }
            } catch (error) {
                throw error;
            }
        },
        async getInfosDepartment(idDepartment){
            var departmenInfos_path = '/index.php/api/department/infos/'+this.idDepartment;
            try{
                const res = await axios.get(departmenInfos_path);
                if(res){
                    const departmentInfos= res.data[0];
                    this.department= departmentInfos;
                    this.title =this.department.name.en;
                    this.wordskeys = this.department.name.en + ' '+this.department.head.last_name+' '+this.department.head.first_name;
                }
            } catch (error) {
                throw error;
            }
        },
        /**
         *  method get list members in departmet in group format
         * @param int idDepartment
         * @param int status , 1 for active member, 0 for former
         * @return array membersBlock contains group of mmembers
         *
        */
        async getResearchers(idDepartment,status){
            var members_path = '/index.php/api/department/researchers/'+this.idDepartment+'/'+status;
            try{
                const res = await axios.get(members_path);
                if(res){
                    const researchers= res.data;
                    if(status == 0)
                        this.membersBlock =   this.getBlockMembre(researchers);
                    else
                        this.membersFormerBlock = this.getBlockMembre(researchers);
                }
            } catch (error) {
                throw error;
            }
        },
        getFormerMembers(){
            this.formerMembers = !this.formerMembers;
            if(this.membersFormerBlock.length == 0 )
                this.getResearchers(this.idDepartment,1);
        },
        getBlockMembre(members){
            var m = [];
            var membersBlock=[];
            var i=0;
            var j=0;
            var nb = members.length;
            var  nb_block = nb;
            if(this.smAndDown){
                nb_block = Math.ceil((nb/2));
            }
            else if(this.mdAndDown){
                nb_block = Math.ceil((nb/3));
            }
            else{
               nb_block = Math.ceil((nb/4));
            }
            members.forEach(function(member){
                j++;
                if(j > nb_block * (i+1)) {
                    membersBlock.push(m);
                    i++;
                    m=[];
                }
                m.push(member);
            });
            membersBlock.push(m);
            return membersBlock;
        },
        // get visitors in current year
        async getVisitors(){
            this.currentVisitors =!this.currentVisitors;
            var visitors_path = '/index.php/api/currentvisitors/'+this.idDepartment;
            try{
                const res = await axios.get(visitors_path);
                if(res){
                    this.visitors= res.data;

                }
            } catch (error) {
                throw error;
            }
        },
    }
}

</script>
<style scoped>
#prod span:hover,
#prod span.router-link-active,
#prod span.router-link-exact-active {
   text-decoration: underline;
   cursor: pointer;
 }
 .productions{
   text-decoration: underline;
    color: #3479B2;
 }

.description{
  font-family: arial, Helvetica, sans-serif;
  font-size: 1.2em;
  font-weight: normal;
  font-stretch:expanded;
}
.lineheight{
    line-height: 1.3;
}

#researchThemes,#scientifiqueProduction{
  list-style-type: square;
}
</style>


